/* Picks product pages: gallery dots, buy now -> checkout, sticky bar, exploded view, tracking. Built by /home/claude/picks/build.py */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var PK = window.PK || {};
  var Q; try { Q = new URLSearchParams(location.search); } catch (e) { Q = { get: function () { return null; } }; }
  var STATIC = Q.get('static') === '1';
  var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function track(name, p) {
    p = p || {}; p.product_handle = PK.handle || null;
    try { if (window.posthog && posthog.capture) posthog.capture(name, p, { send_instantly: true, transport: 'sendBeacon' }); } catch (e) {}
  }
  function fbq(name, params) {
    var tries = 0;
    (function fire() { if (window.fbq) { try { window.fbq('track', name, params); } catch (e) {} return; } if (tries++ < 40) setTimeout(fire, 250); })();
  }

  /* gallery dots */
  var gal = $('[data-gal]'), dots = $$('[data-dots] i');
  if (gal && dots.length) {
    var figs = $$('figure', gal);
    gal.addEventListener('scroll', function () {
      var i = Math.round(gal.scrollLeft / (figs[0].offsetWidth + 8));
      dots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
    }, { passive: true });
    var seen = {};
    gal.addEventListener('scroll', function () { var i = Math.round(gal.scrollLeft / (figs[0].offsetWidth + 8)); if (!seen[i]) { seen[i] = 1; if (i > 0) track('gallery_swipe', { index: i }); } }, { passive: true });
  }

  /* buy now: one product, straight to checkout, with the visit's source on the order */
  function visitAttrs() {
    var a = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { var v = Q.get(k); if (v) a[k] = v; });
    try { var s = JSON.parse(sessionStorage.getItem('pk_visit') || 'null'); if (s) Object.keys(s).forEach(function (k) { if (!a[k]) a[k] = s[k]; }); } catch (e) {}
    try { sessionStorage.setItem('pk_visit', JSON.stringify(a)); } catch (e) {}
    a.pk_landing = PK.handle || ''; return a;
  }
  visitAttrs();
  function post(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body || {}) }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  $$('[data-buy]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (b.getAttribute('aria-busy') === 'true') return;
      b.setAttribute('aria-busy', 'true');
      var vid = PK.variant, at = b.getAttribute('data-buy') || 'main';
      track('buy_clicked', { at: at, variant_id: vid, price: PK.price });
      fbq('AddToCart', { value: PK.price, currency: 'USD', content_ids: [String(vid)], content_type: 'product', content_name: PK.title });
      fbq('InitiateCheckout', { value: PK.price, currency: 'USD', content_ids: [String(vid)], num_items: 1 });
      var go = function () { location.href = '/checkout'; };
      post('/cart/clear.js')
        .then(function () { return post('/cart/add.js', { items: [{ id: Number(vid), quantity: 1 }] }); })
        .then(function () { return post('/cart/update.js', { attributes: visitAttrs() }).catch(function () {}); })
        .then(function () { track('checkout_clicked', { at: at }); setTimeout(go, 120); })
        .catch(function () { location.href = '/cart/' + vid + ':1'; });
    });
  });

  /* sticky bar on phones once the buy button has scrolled off */
  var sticky = $('[data-sticky]'), mainBtn = $('[data-buy="main"]'), fin = $('[data-final]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    var above = false, finOn = false;
    var paintBar = function () { var on = above && !finOn; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); };
    new IntersectionObserver(function (es) { es.forEach(function (e) { above = !e.isIntersecting && e.boundingClientRect.top < 0; paintBar(); }); }).observe(mainBtn);
    if (fin) new IntersectionObserver(function (es) { es.forEach(function (e) { finOn = e.isIntersecting; paintBar(); }); }).observe(fin);
  }

  /* faq + section reach */
  $$('.pk-faq details').forEach(function (d, i) { d.addEventListener('toggle', function () { if (d.open) track('faq_opened', { index: i, q: ($('summary', d) || {}).textContent }); }); });
  if ('IntersectionObserver' in window) {
    var reached = {};
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { var k = e.target.getAttribute('data-reach'); if (e.isIntersecting && !reached[k]) { reached[k] = 1; track('section_reached', { section: k }); } }); }, { threshold: .4 });
    $$('[data-reach]').forEach(function (s) { io.observe(s); });
  }

  /* exploded view: same engine as the Sunday Dog R5 page (class toggle + CSS transitions, geometry computed once) */
  var xsec = $('[data-x-section]'), dataEl = $('#pk-x');
  if (!xsec || !dataEl) return;
  var X; try { X = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var stage = $('[data-x-stage]'), xwrap = $('[data-x-wrap]'), partsBox = $('[data-x-parts]'), svg = $('[data-x-svg]'), ptsBox = $('[data-x-pts]');
  var NS = 'http://www.w3.org/2000/svg', xs = null;
  function clamp(v) { return Math.max(0, Math.min(1, v)); }
  function build() {
    var ar = X.aspect.split('/').map(Number); xs = { ar: ar[0] / ar[1], parts: {}, pts: [], open: null, w: 0 };
    X.parts.forEach(function (p, j) {
      var im = document.createElement('img'); im.className = 'x__part'; im.src = p.src; im.alt = ''; im.style.width = p.w + '%'; im.style.zIndex = p.z || 2;
      im.style.left = p.x + '%'; im.style.top = p.y + '%'; im.style.transitionDelay = (j * 70) + 'ms';
      im.addEventListener('load', function () { layout(true); });
      partsBox.appendChild(im); xs.parts[p.id] = { el: im, p: p };
    });
    X.callouts.forEach(function (c) {
      var e = document.createElement('div'); e.className = 'x__pt x__pt--' + c.side;
      e.innerHTML = '<b></b><span></span>'; e.firstChild.textContent = c.b; e.lastChild.textContent = c.t;
      ptsBox.appendChild(e);
      var line = document.createElementNS(NS, 'line'), dot = document.createElementNS(NS, 'circle'); dot.setAttribute('r', '3.4'); svg.appendChild(line); svg.appendChild(dot);
      xs.pts.push({ el: e, line: line, dot: dot, part: xs.parts[c.part], ax: c.ax != null ? c.ax : .5, ay: c.ay != null ? c.ay : .5, left: c.side === 'l', lab: e.firstChild, y: c.y, on: null });
    });
    layout(true); paint();
  }
  function stack(H) {
    [true, false].forEach(function (left) {
      var col = xs.pts.filter(function (p) { return p.left === left; }).sort(function (a, b) { return a.y - b.y; }), prev = -1e9;
      col.forEach(function (p) { var t = Math.max(p.y * H / 100, prev + 8); p.top = t; prev = t + p.el.offsetHeight; });
      if (prev > H) for (var i = col.length - 1; i >= 0; i--) { var nb = i === col.length - 1 ? H : col[i + 1].top - 8; col[i].top = Math.min(col[i].top, nb - col[i].el.offsetHeight); }
      col.forEach(function (p) { p.el.style.top = Math.max(0, p.top) + 'px'; });
    });
  }
  function layout(force) {
    if (!xs) return;
    var cs = getComputedStyle(xsec), cw = xsec.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    if (!force && cw === xs.w) return; xs.w = cw;
    var desk = window.innerWidth >= 1024, w = Math.min(cw, desk ? 470 : 440), H = w / xs.ar;
    var colW = desk ? Math.max(0, Math.min(330, (cw - w) / 2 - 10)) : 0, WW = w + 2 * colW;
    stage.style.width = w + 'px'; stage.style.height = H + 'px'; stage.style.left = colW + 'px';
    xwrap.style.width = WW + 'px'; xwrap.style.height = H + 'px';
    xwrap.style.setProperty('--colw', colW + 'px');
    xs.pts.forEach(function (pt) { pt.el.style.width = colW > 0 ? (colW - 14) + 'px' : ''; pt.el.style[pt.left ? 'left' : 'right'] = '0px'; });
    Object.keys(xs.parts).forEach(function (id) {
      var o = xs.parts[id], q = o.p, f = q.from || {};
      o.el.style.setProperty('--to', 'translate(-50%,-50%) rotate(' + (q.rot || 0) + 'deg)');
      o.el.style.setProperty('--tc', 'translate(-50%,-50%) translate(' + ((f.dx || 0) * w / 100).toFixed(1) + 'px,' + ((f.dy || 0) * H / 100).toFixed(1) + 'px) rotate(' + ((q.rot || 0) + (f.rot || 0)) + 'deg) scale(' + (f.scale != null ? f.scale : 1) + ')');
      o.el.style.setProperty('--oc', f.op != null ? f.op : 1);
    });
    stack(H);
    svg.setAttribute('viewBox', '0 0 ' + WW + ' ' + H);
    xs.pts.forEach(function (pt) {
      if (!pt.part) return;
      var q = pt.part.p, im = pt.part.el, pw = q.w * w / 100, ph = im.naturalWidth ? pw * im.naturalHeight / im.naturalWidth : pw;
      var cx = colW + q.x * w / 100, cy = q.y * H / 100, r = (q.rot || 0) * Math.PI / 180, ux = (pt.ax - .5) * pw, uy = (pt.ay - .5) * ph;
      var x2 = cx + ux * Math.cos(r) - uy * Math.sin(r), y2 = cy + ux * Math.sin(r) + uy * Math.cos(r);
      var L = pt.lab, top = pt.el.offsetTop + L.offsetTop, x1 = pt.left ? pt.el.offsetLeft + L.offsetLeft + L.offsetWidth + 6 : pt.el.offsetLeft + L.offsetLeft - 6;
      var y1 = top + Math.min(L.offsetHeight / 2, 12);
      pt.line.setAttribute('x1', x1.toFixed(1)); pt.line.setAttribute('y1', y1.toFixed(1)); pt.line.setAttribute('x2', x2.toFixed(1)); pt.line.setAttribute('y2', y2.toFixed(1));
      pt.dot.setAttribute('cx', x2.toFixed(1)); pt.dot.setAttribute('cy', y2.toFixed(1));
      var len = Math.ceil(Math.hypot(x2 - x1, y2 - y1)) + 2; pt.line.style.strokeDasharray = len; pt.line.style.setProperty('--len', len);
    });
  }
  function prog() {
    if (STATIC || REDUCE) return 1;
    var r = stage.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
    var mid = r.top + r.height / 2, start = vh + r.height * .1, end = vh * .45;
    return clamp((start - mid) / (start - end));
  }
  var raf = 0;
  function paint() {
    raf = 0; if (!xs) return;
    var p = prog(), open = p > .25;
    if (open !== xs.open) { xs.open = open; stage.classList.toggle('is-open', open); }
    xs.pts.forEach(function (pt, i) {
      var on = open && p >= .38 + i * .1; if (on === pt.on) return; pt.on = on;
      pt.el.classList.toggle('is-on', on); pt.line.classList.toggle('is-on', on); pt.dot.classList.toggle('is-on', on);
    });
    if (!xs.seen && xs.pts.length && xs.pts[xs.pts.length - 1].on) { xs.seen = true; track('explode_open', {}); }
  }
  function req() { if (!raf) raf = requestAnimationFrame(paint); }
  build();
  window.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', function () { layout(false); req(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { layout(true); req(); });
  window.addEventListener('load', function () { layout(true); req(); });
})();
